import React, { useCallback, useEffect, useState } from 'react';
import GridWrapper from '../../shared/components/layout/GridWrapper';
import Button from '../../shared/components/ui/Button';
import Search from '../../shared/components/ui/Search';
import Layout from '../components/layout/AppLayout';
import Header from '../../shared/components/layout/Header';
import filter from '../../../modules/shared/assets/svg/filter.svg';
import Table from '../../shared/components/layout/Table';
import { transformData } from '../../super-admin/utils/transformData';
import { AddVendor } from '../components/forms/AddVendor';
import Modal from '../../shared/components/ui/Modal';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import {
  buildReturnToFromLocation,
  navigateWithReturn
} from '../../shared/navigation';
import toast from 'react-hot-toast';
import { useForm } from 'react-hook-form';
import { filterData } from '../../shared/utils/filterData';
import {
  createVendor,
  updateVendor,
  getVendorDeleteId,
  getMyVendors,
  getMarketPlaceVendors,
  deleteVendor,
  handleCheckVendorDelete,
  resendEmailInvites,
  getAllCategories,
  importVendor,
  getVendorWhatsappTemplates
} from '../services/api/implementation/impl';
import { useMutation, useQuery } from '@tanstack/react-query';

import { getAllVendor } from '../services/api/implementation/impl';
import PaginationComponent from '../../shared/components/PaginationComponent';
import DeleteConfirmationModal from '../components/ui/DeleteConfirmationModal';
import VendorWhatsAppTemplatesModal from '../components/vendor/VendorWhatsAppTemplatesModal';
import { useSidebar } from '../../shared/contexts/SidebarContext';
import mixpanel from 'mixpanel-browser';
import Cookies from 'js-cookie';
import { MessageCircle } from 'lucide-react';

function getVendorWhatsappTemplatesBadge(data) {
  if (!data) return null;
  const events = data.events || [];
  if (!data.whatsapp_configured) {
    return {
      label: 'Not set',
      className: 'border-gray-200 bg-gray-50 text-gray-600'
    };
  }
  if (!events.length) {
    return {
      label: 'Not set',
      className: 'border-gray-200 bg-gray-50 text-gray-600'
    };
  }
  const statuses = events.map((e) => String(e?.status || 'DRAFT').toUpperCase());
  const allApproved = statuses.every((s) => s === 'APPROVED' || s === 'ACTIVE');
  const allEnabled = events.every((e) => !!e.enabled);
  if (allApproved && allEnabled) {
    return {
      label: 'Set',
      className: 'border-emerald-200 bg-emerald-50 text-emerald-800'
    };
  }
  if (statuses.some((s) => s === 'PENDING' || s === 'IN_REVIEW')) {
    return {
      label: 'Pending',
      className: 'border-amber-200 bg-amber-50 text-amber-800'
    };
  }
  if (statuses.some((s) => s === 'REJECTED' || s === 'FAILED')) {
    return {
      label: 'Rejected',
      className: 'border-rose-200 bg-rose-50 text-rose-800'
    };
  }
  return {
    label: 'Not set',
    className: 'border-gray-200 bg-gray-50 text-gray-600'
  };
}
const VendorList = () => {
  const userId = Cookies.get('userId');
  /* 
    Hooks
  */
  const navigate = useNavigate();
  const location = useLocation();

  // State for pagination, search, modal control, and vendors data
  const [page, setPage] = useState(1);
  const [limit] = useState(500); // items per page
  const [searchQuery, setSearchQuery] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [OpenAddVendor, setOpenAddVendor] = useState(false);
  const [isOpenEditVendor, setIsOpenEditVendor] = useState(false);
  const [isWhatsAppTemplatesOpen, setIsWhatsAppTemplatesOpen] = useState(false);
  const [vendors, setVendors] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [activeTab, setActiveTab] = useState('myVendors'); // 'myVendors' or 'marketplace'
  const [modalType, setModalType] = useState('Add');
  const [selectedVendor, setSelectedVendor] = useState();
  const [canDelete, setCanDelete] = useState(null);
  const [resData, setResData] = useState();
  const [selectedIds, setSelectedIds] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [categories, setCategories] = useState([]);
  const { collapsed } = useSidebar();
  const [showCategories, setShowCategories] = useState(false);
  const [cityFilter, setCityFilter] = useState('');
  const [categoryFilter, setCategoryFilter] = useState('');
  const [importData, setImportData] = useState({
    vendor_id: null,
    category_ids: []
  });
  // const { data: allVendors, refetch: refetchVendors } = useQuery({
  //   queryKey: ['vendor'],
  //   queryFn: getAllVendor
  // });

  // const { data: DeleteVendorById, refetch: refetchDeleteById } = useQuery({
  //   queryKey: ['deletebyId'],
  //   queryFn: getVendorById
  // });

  // Fetch vendors data with pagination
  const {
    data: allVendors,
    refetch: refetchVendors,
    isFetching
  } = useQuery({
    queryKey: ['vendor', activeTab, page, cityFilter, categoryFilter],
    queryFn: () =>
      activeTab === 'myVendors'
        ? getMyVendors(page, limit, cityFilter, categoryFilter)
        : getMarketPlaceVendors(page, limit, cityFilter, categoryFilter)
  });

  //refetch vendors when component mounts

  // Track page view
  useEffect(() => {
    mixpanel.track('Vendor List Viewed', {
      user_id: userId,
      timestamp: new Date().toISOString()
    });
  }, [userId]);

  useEffect(() => {
    refetchVendors();
  }, []);

  console.log('vendors', allVendors);

  //stare the all vendors in the vendors state
  useEffect(() => {
    if (allVendors?.data) {
      setVendors(allVendors?.data);
      setFilteredData(allVendors?.data);
    }
  }, [allVendors?.data]);

  const { data: allcategory, refetch: refetchAllcategory } = useQuery({
    queryKey: ['category'],
    queryFn: () => getAllCategories(1, 500),
    keepPreviousData: true
  });

  const { data: vendorWhatsappTemplates } = useQuery({
    queryKey: ['vendorWhatsappTemplates'],
    queryFn: getVendorWhatsappTemplates,
    enabled: activeTab === 'myVendors'
  });
  const whatsappTemplatesBadge = getVendorWhatsappTemplatesBadge(vendorWhatsappTemplates);

  useEffect(() => {
    if (allcategory?.data) {
      refetchAllcategory();
    }
  }, []);

  useEffect(() => {
    if (allcategory?.data) {
      setCategories(allcategory?.data);
    }
  }, [allcategory?.data]);

  const { mutate: handleCreateVendor } = useMutation({
    mutationFn: (payload) => createVendor(payload),
    onMutate: (variables) => {
      setIsSubmitting(true); // Disable the button when mutation starts
      mixpanel.track('Create Vendor Started', {
        user_id: userId,
        vendor_name: variables?.name,
        timestamp: new Date().toISOString()
      });
    },
    onSuccess: async (result, variables) => {
      setIsSubmitting(false);

      // Check if result is an error object (API now returns errors instead of throwing)
      if (
        result?.response?.status ||
        result?.message?.includes('Error') ||
        result?.name === 'AxiosError'
      ) {
        console.error('Error creating new vendor', result);
        toast.error(
          result?.response?.data?.message || result?.message || 'Error creating new vendor'
        );

        mixpanel.track('Create Vendor Failed', {
          user_id: userId,
          vendor_name: variables?.name,
          error_message: result?.response?.data?.message || result?.message || 'Unknown error',
          timestamp: new Date().toISOString()
        });
        return;
      }

      toast.success('Vendor created successfully');
      refetchVendors();
      setVendors([...vendors, result]);
      setFilteredData([...vendors, result]);
      setOpenAddVendor(false);

      mixpanel.track('Create Vendor Success', {
        user_id: userId,
        vendor_id: result?.id,
        vendor_name: variables?.name || result?.name,
        timestamp: new Date().toISOString()
      });
    },
    onError: (err, variables) => {
      setIsSubmitting(false);
      console.error('Error creating new vendor', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error creating new vendor');

      mixpanel.track('Create Vendor Failed', {
        user_id: userId,
        vendor_name: variables?.name,
        error_message: err?.response?.data?.message || err?.message || 'Unknown error',
        timestamp: new Date().toISOString()
      });
    }
  });

  const { mutate: handleUpdateVendor } = useMutation({
    mutationFn: (payload) => updateVendor(selectedVendor.id, payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async (data) => {
      setIsSubmitting(false);
      toast.success('Vendor updated successfully');
      refetchVendors();
      setVendors([...vendors, data]);
      setFilteredData([...vendors, data]);
      setIsOpenEditVendor(false);
      setSelectedVendor();
      setModalType('Add');
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error updating vendor', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error updating vendor', err);
    }
  });

  const handleSearch = (data) => {
    setSearchQuery(data);
  };

  const handleOnClickSearch = () => {
    const filtered = vendors.filter((item) =>
      item.name.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredData(filtered);
    setSearchQuery('');
  };

  /* 
    Event handlers
  */
  const handleToggleAddVendor = () => {
    setModalType('Add');
    setOpenAddVendor(!OpenAddVendor);
  };

  const handleToggleEditVendor = (id) => {
    const data = filteredData.find((item) => item.id === parseInt(id));

    if (data) {
      setSelectedVendor(data);
      setIsOpenEditVendor(!isOpenEditVendor);
      setModalType('Edit');
    } else {
      toast.error('Vendor Data Not Foud');
    }
  };

  const handleNavigateVendor = (id) => {
    navigateWithReturn(navigate, `/builder/vendors/${id}`, {
      returnTo: buildReturnToFromLocation(location)
    });
  };

  const vendorsDataFormat = [
    'id',
    'businessName',
    'name',
    'phone_number',
    'categories',
    'city',
    'status',
    'invite',
    'actions'
  ];

  const { reset } = useForm();

  useEffect(() => {
    setFilteredData(vendors);
  }, [vendors]);

  const handleSearchChange = useCallback(
    (incomingQuery) => {
      setSearchQuery(incomingQuery);
      const lowerCaseQuery = incomingQuery.toLowerCase();

      if (incomingQuery) {
        const filteredVendors = vendors.filter((vendor) => {
          // Search across multiple fields (city filter is handled by backend)
          return (
            vendor.businessName?.toLowerCase().includes(lowerCaseQuery) ||
            vendor.user?.name?.toLowerCase().includes(lowerCaseQuery) ||
            vendor.user?.email?.toLowerCase().includes(lowerCaseQuery) ||
            vendor.user?.phone_number?.toLowerCase().includes(lowerCaseQuery)
          );
        });

        setFilteredData(filteredVendors);
      } else {
        // Reset to all vendors if query is empty
        setFilteredData(vendors);
      }
    },
    [vendors]
  );

  const handleVendorFormat = (item) => {
    // Extract and join category names
    const categories =
      item?.vendorCategoryMapping
        ?.map((mapping) => mapping?.categroy?.name)
        .filter(Boolean)
        .join(', ') || '-';

    return {
      id: item.id,
      name: item?.user?.name,
      businessName: item?.businessName,
      phone_number: item?.user?.phone_number,
      categories: categories,
      city: item?.city,
      status: item?.is_onboarded == true ? 'Active' : 'Inactive',
      invite: `Invite ${item?.user?.is_active}`
    };
  };

  // onSubmit button function for adding vendor
  const onSubmit_Vendor = (data) => {
    const newVendor = { ...data, id: vendors.length + 1 };
    setVendors([...vendors, newVendor]);
    setFilteredData([...vendors, newVendor]);
    setOpenAddVendor(false);
    toast.success('Vendor created successfully');
    reset();
  };

  // Add tab change handler
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setVendors([]); // Clear current vendors
    setFilteredData([]); // Clear filtered data
    setCityFilter(''); // Reset city filter
    setCategoryFilter(''); // Reset category filter
    setSearchQuery(''); // Reset search query
    setPage(1); // Reset to first page
  };

  // Transformation of the vendor data
  const transformedData = filteredData
    ?.slice()
    .sort((a, b) => {
      const nameA = (a.businessName || '').toLowerCase();
      const nameB = (b.businessName || '').toLowerCase();
      return nameA.localeCompare(nameB);
    })
    ?.map((item) => transformData(handleVendorFormat(item), vendorsDataFormat));

  const transformedList = filteredData?.map((item) =>
    transformData(handleVendorFormat(item), vendorsDataFormat)
  );

  //delete functions

  const { mutate: handleCheckDelete } = useMutation({
    mutationFn: (id) => handleCheckVendorDelete(id),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async (res, id) => {
      setIsSubmitting(false);
      const vendor = transformedList?.find((item) => parseInt(item.id) === parseInt(id));

      const vendorName = vendor?.name || 'vendor';
      if (res.canDelete) {
        setCanDelete('yes');
        setResData({ name: vendorName });
        setSelectedIds([parseInt(id)]);
      } else {
        // Fallback if not found
        setResData({ ...res, name: vendorName });
        setCanDelete('no');
      }
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error checking vendor', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error checking vendor');
    }
  });

  const { mutate: handleDeleteFn } = useMutation({
    mutationFn: (payload) => deleteVendor(payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async () => {
      setIsSubmitting(false);
      toast.success('Vendor Deleted Successfully');

      // Refetch the data
      const result = await refetchVendors();
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error deleting vendor', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error deleting vendor');
    }
  });

  const HandleDelete = (data) => {
    const payload = { ids: data };
    handleDeleteFn(payload);
  };

  //wriet useMutation for resendEmailInvites
  const { mutate: resendInvite } = useMutation({
    mutationFn: (payload) => resendEmailInvites(payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async (res) => {
      setIsSubmitting(false);
      console.log({ res });
      toast.success('Invite sent successfully');
      console.log('Invite sent successfully');
      await refetchVendors(); // UI data update
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error sending invite');
    }
  });

  const handleResendInvite = (id) => {
    const users = filteredData?.filter((user) => parseInt(user.id) === parseInt(id));
    const email = users[0]?.user?.email;
    resendInvite({ email });
  };

  const handleOnImport = (id) => {
    if (id) {
      setImportData((prev) => ({ ...prev, vendor_id: id }));
      setShowCategories(true);
    }
  };

  const onCloseImport = () => {
    setImportData({
      vendor_id: null,
      category_ids: []
    });
    setShowCategories(false);
  };

  const onCheck = (id, checked) => {
    setImportData((prev) => {
      const category_ids = checked
        ? [...prev.category_ids, id] // add if checked
        : prev.category_ids.filter((catId) => catId !== id); // remove if unchecked

      return { ...prev, category_ids };
    });
  };

  const { mutate: handImportFn } = useMutation({
    mutationFn: (payload) => importVendor(payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async () => {
      setIsSubmitting(false);
      toast.success('Vendor Imported Successfully');
      refetchVendors();
      onCloseImport();
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error Importing vendor', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error Importing vendor');
    }
  });

  const handleImport = () => {
    const payload = importData;
    handImportFn(payload);
  };

  // Comprehensive list of Indian cities
  const indianCities = React.useMemo(
    () => [
      'Agartala',
      'Agra',
      'Ahmedabad',
      'Aizawl',
      'Ajmer',
      'Akola',
      'Aligarh',
      'Alappuzha',
      'Allahabad',
      'Almora',
      'Alwar',
      'Amaravati',
      'Ambala',
      'Amravati',
      'Amritsar',
      'Anand',
      'Anantapur',
      'Asansol',
      'Aurangabad',
      'Baharampur',
      'Bahraich',
      'Ballari',
      'Bangalore',
      'Barasat',
      'Bareilly',
      'Bathinda',
      'Begusarai',
      'Belgaum',
      'Bellary',
      'Bhagalpur',
      'Bharatpur',
      'Bharuch',
      'Bhatpara',
      'Bhavnagar',
      'Bhilai',
      'Bhilwara',
      'Bhiwandi',
      'Bhiwani',
      'Bhopal',
      'Bhubaneswar',
      'Bidar',
      'Bijapur',
      'Bikaner',
      'Bilaspur',
      'Bokaro',
      'Burdwan',
      'Chandigarh',
      'Chandrapur',
      'Chennai',
      'Chhapra',
      'Coimbatore',
      'Cuttack',
      'Darbhanga',
      'Davangere',
      'Dehradun',
      'Delhi',
      'Dhanbad',
      'Dharamshala',
      'Dhule',
      'Dibrugarh',
      'Dindigul',
      'Dispur',
      'Durg',
      'Durgapur',
      'Erode',
      'Faizabad',
      'Faridabad',
      'Farrukhabad',
      'Firozabad',
      'Gandhidham',
      'Gandhinagar',
      'Gangtok',
      'Gaya',
      'Ghaziabad',
      'Goa',
      'Gopalpur',
      'Gorakhpur',
      'Gulbarga',
      'Guna',
      'Guntur',
      'Gurgaon',
      'Guwahati',
      'Gwalior',
      'Hajipur',
      'Haldia',
      'Hapur',
      'Haridwar',
      'Hazaribagh',
      'Hisar',
      'Hospet',
      'Hosur',
      'Howrah',
      'Hubli',
      'Hyderabad',
      'Imphal',
      'Indore',
      'Itanagar',
      'Jabalpur',
      'Jaipur',
      'Jalandhar',
      'Jalgaon',
      'Jammu',
      'Jamnagar',
      'Jamshedpur',
      'Jhansi',
      'Jodhpur',
      'Jorhat',
      'Junagadh',
      'Kadapa',
      'Kakinada',
      'Kalyan',
      'Kamarhati',
      'Kanpur',
      'Kannur',
      'Karaikudi',
      'Karimnagar',
      'Karnal',
      'Karur',
      'Kavaratti',
      'Khammam',
      'Khandwa',
      'Kharagpur',
      'Kirari Suleman Nagar',
      'Kishangarh',
      'Kochi',
      'Kohima',
      'Kolhapur',
      'Kolkata',
      'Kollam',
      'Korba',
      'Kota',
      'Kottayam',
      'Kozhikode',
      'Kumbakonam',
      'Kurnool',
      'Latur',
      'Loni',
      'Lucknow',
      'Ludhiana',
      'Madurai',
      'Maheshtala',
      'Malegaon',
      'Mangalore',
      'Mathura',
      'Mau',
      'Medinipur',
      'Meerut',
      'Mirzapur',
      'Moradabad',
      'Morbi',
      'Mumbai',
      'Munger',
      'Muzaffarnagar',
      'Muzaffarpur',
      'Mysore',
      'Nadiad',
      'Nagercoil',
      'Nagpur',
      'Naihati',
      'Nanded',
      'Nandyal',
      'Nashik',
      'Navi Mumbai',
      'Nellore',
      'New Delhi',
      'Nizamabad',
      'Noida',
      'Ongole',
      'Orai',
      'Pali',
      'Palwal',
      'Panaji',
      'Panipat',
      'Parbhani',
      'Patiala',
      'Patna',
      'Pilibhit',
      'Pimpri-Chinchwad',
      'Pondicherry',
      'Porbandar',
      'Port Blair',
      'Puducherry',
      'Pune',
      'Puri',
      'Purnia',
      'Raebareli',
      'Raichur',
      'Raigarh',
      'Raipur',
      'Rajahmundry',
      'Rajapalayam',
      'Rajkot',
      'Ramagundam',
      'Rampur',
      'Ranchi',
      'Ratlam',
      'Raurkela',
      'Rewari',
      'Rohtak',
      'Roorkee',
      'Rourkela',
      'Sagar',
      'Saharanpur',
      'Salem',
      'Sambalpur',
      'Sangli',
      'Satara',
      'Satna',
      'Secunderabad',
      'Shahjahanpur',
      'Shillong',
      'Shimla',
      'Shimoga',
      'Sikar',
      'Silchar',
      'Siliguri',
      'Silvassa',
      'Singrauli',
      'Sirsa',
      'Sitapur',
      'Siwan',
      'Solapur',
      'Sonipat',
      'South Dumdum',
      'Sri Ganganagar',
      'Srinagar',
      'Sultanpur',
      'Surat',
      'Surendranagar',
      'Suryapet',
      'Thane',
      'Thanjavur',
      'Thiruvananthapuram',
      'Thrissur',
      'Tindivanam',
      'Tirunelveli',
      'Tirupati',
      'Tiruppur',
      'Tiruchirappalli',
      'Tiruvallur',
      'Tiruvannamalai',
      'Tumkur',
      'Udaipur',
      'Udupi',
      'Ujjain',
      'Ulhasnagar',
      'Unnao',
      'Vadodara',
      'Valsad',
      'Varanasi',
      'Vasai-Virar',
      'Vellore',
      'Vijayawada',
      'Visakhapatnam',
      'Vizianagaram',
      'Warangal',
      'Yamuna Nagar'
    ],
    []
  );

  // Get city options for dropdown
  const cityOptions = React.useMemo(() => {
    return [
      { id: '', label: cityFilter ? 'Clear Filter' : 'Select City' },
      ...indianCities.map((city) => ({
        id: city,
        label: city
      }))
    ];
  }, [indianCities, cityFilter]);

  const handleCityFilterChange = (cityValue) => {
    setCityFilter(cityValue);
    setPage(1); // Reset to first page when filter changes
  };

  // Get category options for dropdown
  const categoryOptions = React.useMemo(() => {
    if (!categories || categories.length === 0) return [];

    return [
      { id: '', label: categoryFilter ? 'Clear Filter' : 'Select Category' },
      ...categories
        .sort((a, b) => (a.name || '').localeCompare(b.name || ''))
        .map((category) => ({
          id: category.id,
          label: category.name
        }))
    ];
  }, [categories, categoryFilter]);

  const handleCategoryFilterChange = (categoryValue) => {
    setCategoryFilter(categoryValue);
    setPage(1); // Reset to first page when filter changes
  };

  return (
    <>
      <VendorWhatsAppTemplatesModal
        isOpen={isWhatsAppTemplatesOpen}
        onClose={() => setIsWhatsAppTemplatesOpen(false)}
      />

      {/* Add vendor form */}
      {OpenAddVendor && (
        <Modal
          isDirty={true}
          confirmOnClose={true}
          width={56}
          name="Add Vendor"
          onClose={handleToggleAddVendor}>
          <AddVendor
            isSubmitting={isSubmitting}
            onSubmit={handleCreateVendor}
            onClose={handleToggleAddVendor}
            modalType={modalType}
            setModalType={setModalType}
            refetchVendors={refetchVendors}
            setOpenAddVendor={setOpenAddVendor}
            OpenAddVendor={OpenAddVendor}
          />
        </Modal>
      )}

      {/* Edit vendor form */}
      {isOpenEditVendor && (
        <Modal
          isDirty={true}
          confirmOnClose={true}
          width={56}
          name="Edit Vendor"
          onClose={() => setIsOpenEditVendor(false)}>
          <AddVendor
            isSubmitting={isSubmitting}
            onSubmit={handleUpdateVendor}
            onClose={() => setIsOpenEditVendor(false)}
            modalType={modalType}
            selectedVendor={selectedVendor}
            setModalType={setModalType}
          />
        </Modal>
      )}

      {canDelete === 'no' && (
        <Modal
          isDirty={true}
          confirmOnClose={false}
          name={`Cannot delete '${resData?.name || 'this requirement'}'`}
          onClose={() => setCanDelete(null)}
          width={45}>
          <div className="flex flex-col justify-center align-center ">
            <p className="text-center">Looks like there is requested quotation.</p>
            {/* <div className="flex justify-start, align-middle flex-wrap bg-[#f5f7f8] p-2 rounded-[5px] mt-4">
              {resData &&
                resData.reason?.map((r, index) => (
                  <span className="mt-[2px] mr-[4px] text-[#535353]" key={index}>
                    {index + 1}.{r}
                    {index < resData.reason.length - 1 ? ', ' : ''}
                  </span>
                ))}
            </div> */}
          </div>
        </Modal>
      )}

      {canDelete === 'yes' && (
        <Modal
          isDirty={true}
          confirmOnClose={false}
          name={'Confirmation'}
          onClose={() => {
            setCanDelete(null);
            setSelectedIds([]);
          }}
          width={45}>
          <DeleteConfirmationModal
            name={resData.name}
            title={'vendor'}
            onClose={() => setCanDelete(null)}
            data={transformedList}
            type={'vendor'}
            setCanDelete={setCanDelete}
            onDeleteClick={HandleDelete}
            setSelectedIds={setSelectedIds}
            selectedIds={selectedIds}
          />
        </Modal>
      )}

      {showCategories && (
        <Modal
          isDirty={true}
          confirmOnClose={false}
          name={'Select Categories'}
          onClose={onCloseImport}
          width={45}>
          <div className="flex flex-col justify-center align-center ">
            <div className="flex flex-col justify-start, align-middle bg-[#f5f7f8] p-2 rounded-[5px] mt-4 max-h-[20rem] overflow-auto">
              {categories &&
                categories.map((r, index) => (
                  <div key={index} className="flex gap-1">
                    <input
                      type="checkbox"
                      checked={importData.category_ids.includes(r.id)}
                      onChange={(e) => onCheck(r.id, e.target.checked)}
                    />
                    <span className="mt-[2px] mr-[4px] text-[#535353]">{r.name}</span>
                  </div>
                ))}
            </div>
            <div className="w-full flex justify-end items-center space-x-4 mt-8">
              <Button type="button" onClick={onCloseImport} displayType="secondary">
                Cancel
              </Button>
              <Button type="button" onClick={handleImport}>
                Import
              </Button>
            </div>
          </div>
        </Modal>
      )}

      <Layout>
        {/* Header */}
        <div
          className={`fixed z-[10] top-0 transition-all duration-300 ease-in-out ${
            collapsed ? 'left-[76px] right-0' : 'left-64 right-0'
          }`}>
          <Header data={{ name: 'Vendors' }} />
        </div>

        <div
          className={`transition-all duration-300 ease-in-out ${collapsed ? 'ml-[1vw] relative' : ''}`}>
          {' '}
          {/* Search and Add button bar */}
          <div
            className={`flex z-20 items-center justify-between px-6 py-4 bg-white fixed top-[4rem] border-t-[2px] border-stone-100 shadow-sm    transition-all duration-300 ease-in-out ${
              collapsed ? 'left-[76px] right-0' : 'left-64 right-0'
            }`}>
            <Search
              onChange={handleSearchChange}
              query={searchQuery}
              onClick={handleOnClickSearch}
            />
            <div className="flex gap-3 cursor-pointer items-center">
              {activeTab === 'myVendors' && (
                <>
                  <button
                    type="button"
                    onClick={() => setIsWhatsAppTemplatesOpen(true)}
                    className="inline-flex items-center gap-1.5 rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-50 transition-colors">
                    <MessageCircle className="h-4 w-4 shrink-0" />
                    Vendor WhatsApp templates
                    {whatsappTemplatesBadge ? (
                      <span
                        className={`ml-0.5 inline-flex rounded-full border px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider ${whatsappTemplatesBadge.className}`}>
                        {whatsappTemplatesBadge.label}
                      </span>
                    ) : null}
                  </button>
                  <Button onClick={handleToggleAddVendor}>Add Vendor</Button>
                </>
              )}
            </div>
          </div>
          {/* Tabs - Moved below search box */}
          <div
            className={`fixed top-[8rem] z-30 bg-white px-6 py-4 transition-all duration-300 ease-in-out ${
              collapsed ? 'left-[76px] right-0' : 'left-64 right-0'
            }`}>
            <div className="flex gap-8">
              <button
                className={`text-lg font-semibold transition-colors duration-200 ${
                  activeTab === 'myVendors' ? 'text-[#2A565E]' : 'text-gray-400 hover:text-gray-600'
                }`}
                // onClick={() => handleTabChange('myVendors')}
                >
                My Vendors
              </button>

              {/* MarketPlace for vendors */}
              {/* <button
                className={`text-lg font-semibold transition-colors duration-200 ${
                  activeTab === 'marketplace'
                    ? 'text-[#2A565E]'
                    : 'text-gray-400 hover:text-gray-600'
                }`}
                onClick={() => handleTabChange('marketplace')}>
                Marketplace
              </button> */}
            </div>
            <div className="mt-2">
              <div
                className="h-[2px] bg-[#2A565E] transition-all duration-300 ease-in-out"
                style={{
                  width: activeTab === 'myVendors' ? '95px' : '100px',
                  transform: `translateX(${activeTab === 'myVendors' ? '0' : '130px'})`
                }}
              />
            </div>
          </div>
        </div>

        {/* Grid - adjusted margin top to account for new tab position */}
        <div className={`transition-all duration-300 ease-in-out ${collapsed ? 'ml-[1vw]' : ''}`}>
          <GridWrapper width={100}>
            <div className="mt-[14rem] h-[28rem] relative">
              <Table
                headers={[
                  'Business Name',
                  'Contact Person Name',
                  'Phone',
                  {
                    label: 'Categories',
                    dropdown: true,
                    dropdownOptions: categoryOptions,
                    selectedValue: categoryFilter,
                    onDropdownSelect: handleCategoryFilterChange
                  },
                  {
                    label: 'City',
                    dropdown: true,
                    dropdownOptions: cityOptions,
                    selectedValue: cityFilter,
                    onDropdownSelect: handleCityFilterChange
                  },
                  'Status',
                  'Invite',
                  'Actions'
                ]}
                data={transformedData}
                identifier={'id'}
                onEdit={handleToggleEditVendor}
                handleRowClick={handleNavigateVendor}
                //isViewEnable={true}
                isEditEnable={true}
                isDeleteEnable={true}
                onDelete={handleCheckDelete}
                onResendInvite={(id) => handleResendInvite(id)}
                isImportEnable={activeTab !== 'myVendors'}
                onImport={handleOnImport}
                isWrap={true}
              />
            </div>
          </GridWrapper>
        </div>
      </Layout>
    </>
  );
};

export default VendorList;
